import styled from "styled-components";
import { mobileBoundryWidth } from "../../../themes";

export const BusinessLogo = styled.img`
    object-fit: contain;

    @media (max-width: ${mobileBoundryWidth}px) {
        border-right: 1px lightgrey solid;
    }
`;